import React from "react"
import { DatePicker } from "rsuite"

const DATE_VALUE_PATTERN = /^\d{4}-\d{2}-\d{2}$/

const formatDateValue = date => {
  if (!date) return ""
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`
}

const isValidDateString = value =>
  typeof value === "string" && DATE_VALUE_PATTERN.test(value)

/**
 * RSuite DatePicker that stores values as `yyyy-MM-dd`.
 * Calendar language comes from the app-level RsuiteLocaleProvider.
 */
const LocalizedDatePicker = ({
  value,
  onChange,
  placeholder,
  className,
  cleanable = true,
  editable = true,
  ...rest
}) => {
  const dateValue = value ? new Date(`${value}T00:00:00`) : null
  const parsedDate =
    dateValue && !Number.isNaN(dateValue.getTime()) ? dateValue : null

  return (
    <DatePicker
      block
      format="yyyy-MM-dd"
      value={parsedDate}
      onChange={date => {
        if (!date) {
          if (cleanable) onChange("")
          return
        }
        const formatted = formatDateValue(date)
        if (!isValidDateString(formatted)) return
        onChange(formatted)
      }}
      placeholder={placeholder}
      className={className}
      cleanable={cleanable}
      editable={editable}
      {...rest}
    />
  )
}

export default LocalizedDatePicker
